import { renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    (_ctx.show)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          ref: "popover",
          class: "popover",
          style: _normalizeStyle({ ..._ctx.style, ..._ctx.pos })
        }, [
          _renderSlot(_ctx.$slots, "default", {}, undefined, true)
        ], 4 /* STYLE */))
      : _createCommentVNode("v-if", true)
  ]))
}